import type { State } from '@zcode/state-type'
import * as ActionC from '../constants'

export function getCurrentLocation(state: State) {
  return state.currentSearch.location
}

export function checkSaveSearchCreateView(state: State) {
  return state.searchUI && state.searchUI.searchView === ActionC.SEARCH_VIEW_TYPE.SAVE_SEARCH_CREATE
}
